module.exports = __webpack_public_path__ + "assets/images/site.50b6c3442173c5bbe3818b84790c273e.png";